import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class WorkTicketMaterialModel {


    constructor() {

        this.id = null;
        this.work_ticket_id = null;
        this.date_id = null;
        this.quantity = null;
        this.make = null;
        this.model = null;
        this.mat_description = null;


    }


    static fromJson(object) {
        return fromJson((new WorkTicketMaterialModel()), object);
    }

}

export default WorkTicketMaterialModel;
